import { defineMessages } from 'react-intl';

export default defineMessages({
  storage: {
    id: 'component.settingsNavigation.storage',
    defaultMessage: 'Storage',
  },
  security: {
    id: 'component.settingsNavigation.security',
    defaultMessage: 'Security',
  },
  image: {
    id: 'component.settingsNavigation.image',
    defaultMessage: 'Image',
  },
  watermark: {
    id: 'component.settingsNavigation.watermark',
    defaultMessage: 'Watermark',
  },
  video: {
    id: 'component.settingsNavigation.video',
    defaultMessage: 'Video',
  },
  webhook: {
    id: 'component.settingsNavigation.webhook',
    defaultMessage: 'Webhook',
  },
  database: {
    id: 'component.settingsNavigation.database',
    defaultMessage: 'Database',
  },
  metadata: {
    id: 'component.settingsNavigation.metadata',
    defaultMessage: 'Metadata',
  },
  versions: {
    id: 'component.settingsNavigation.versions',
    defaultMessage: 'Asset Versions',
  },
  addons: {
    id: 'component.settingsNavigation.addons',
    defaultMessage: 'Add-ons',
  },
  tools: {
    id: 'component.settingsNavigation.tools',
    defaultMessage: 'Tools',
  },
  processingQueues: {
    id: 'component.settingsNavigation.processingQueues',
    defaultMessage: 'Task Queues',
  },
  notifications: {
    id: 'component.settingsNavigation.notifications',
    defaultMessage: 'Notifications',
  },
  aiAgent: {
    id: 'component.settingsNavigation.aiAgent',
    defaultMessage: 'AI',
  },
  saveTemplate: {
    id: 'component.settingsNavigation.saveTemplate',
    defaultMessage: 'Save Settings as Template',
  },
});
